module.exports = __webpack_public_path__ + "static/media/Figure8.87d0ac1c.jpg";